import httpRequest from 'superagent';
import SearchEngine from '../../common/search/search-engine';


class SlxSearchEngine extends SearchEngine {


	constructor({searchUrl}) {
		super();
		this.searchUrl = searchUrl;
	}


	search(params) {
		const req = httpRequest
			.get(this.searchUrl)
			// .timeout(this.timeout)
			.set('X-Requested-With', 'XMLHttpRequest')
			.set('Accept', 'application/json')
			.query({
				q: params.search,
				ajax: 'true',
				format: 'html'
			})
		;
		return new Promise((resolve) => {
			req.end((error, response) => {
				if (!error && response.ok) {
					const results = response.body;
					results.params = {
						inputSearch: results.query,
						page: 1
					};
					resolve(results);
				} else if (error && error.status === 404) {
					resolve(error.response.body);
				} else {
					if (!error.response) {
						error.response = response;
					}
					throw error;
				}
			});
		});
	}


	track(params) {
		return Promise.resolve({});
	}

}


export default SlxSearchEngine;
